import apiClient from '../config/api';
import { getUserId } from '../config/constants';
/**
 * Servicio para todas las operaciones relacionadas con talleres
 */
export const workshopService = {
    /**
     * Listar todos los talleres de un usuario
     * GET /workshops/all/{user_id}
     */
    getWorkshops: async () => {
        const response = await apiClient.get(`/workshops/all`);
        return response.data;
    },

    /**
     * Obtener un taller específico por ID
     * GET /{workshop_id}
     */
    getWorkshopById: async (workshopId) => {
        const response = await apiClient.get(`/${workshopId}`);
        return response.data;
    },

    /**
     * Crear un nuevo taller
     * POST /workshop
     * 
     * @param {Object} workshopData - Datos del taller
     * @param {String} workshopData.name - Nombre del taller
     * @param {String} workshopData.address - Dirección del taller
     * @param {String} workshopData.owner_id - ID del propietario (opcional, se obtiene automáticamente)
     * @param {Array} workshopData.admins - Lista de administradores (opcional)
     * @param {Array} workshopData.technicians - Lista de técnicos (opcional)
     */
    createWorkshop: async (workshopData) => {
        const ownerId = getUserId();

        if (!ownerId) {
            throw new Error('No se pudo resolver owner_id para crear el taller');
        }

        const payload = {
            owner_id: ownerId,
            name: workshopData.name,
            address: workshopData.address,
        };

        const response = await apiClient.post('/workshop', payload);
        return response.data;
    },

    /**
     * Eliminar un taller por ID
     * DELETE /workshop/{id}
     */
    deleteWorkshop: async (workshopId) => {
        if (!workshopId) {
            throw new Error('ID de taller inválido');
        }

        const attempts = [
            () => apiClient.delete(`/workshop/${workshopId}`),
            () => apiClient.delete(`/workshops/${workshopId}`),
        ];

        let lastError = null;

        for (const request of attempts) {
            try {
                const response = await request();
                return response.data;
            } catch (error) {
                // Si la ruta no existe, probamos la siguiente variante conocida.
                if (error?.response?.status === 404) {
                    lastError = error;
                    continue;
                }
                throw error;
            }
        }

        throw lastError || new Error('No se pudo eliminar el taller');
    }
};